export default {
  answers: [],
  answerTexts: [
    {
      'title': 'Homero Simpson',
      'quote': '¡Felicitaciones! Eres igual que el personaje principal de la serie norteamericana los Simpson. Sigue con la cerveza en la mano. Lo tuyo definitivamente no son los deportes. '
    },
    {
      'title': 'Amante de la TV',
      'quote': 'Poco ejercicio y mucho control remoto. Te cansas sólo de tanto apretar el control remoto. Vamos, levántate de tu asiento y prepárate mejor para la próxima.'
    },
    {
      'title': 'Picapiedra',
      'quote': 'Lo tuyo no son los deportes. Te mueves menos que una persona en un ascensor. Haces lo justo y necesario en la oficina y hasta le pides permiso a tu mano para apretar una tecla en el computador.'
    },
    {
      'title': 'Pichanguero',
      'quote': 'Piensas que porque juegas fútbol te crees un deportista top. Pero te cuento que pegarle a la pelota no es lo mismo que nadar, andar en bicicleta y trotar en una misma prueba. Vamos, sigue intentando, pero ahora sin balón.'
    },
    {
      'title': 'Principiante',
      'quote': 'Probablemente recién estás empezando en el mundo del triatlón. Todavía no tienes conocimientos en el nado y ciclismo, y sólo te preparas para correr. Pero no te preocupes, todos nos demoramos en tener buen estado físico.'
    },
    {
      'title': 'Amateur en las pistas',
      'quote': 'No llevas mucho tiempo preparándote para este tipo de pruebas. Para ti lo primordial es tener unas buenas zapatillas y ropa adecuada. Te invitamos a prepararte mejor y superarte un poco día a día.'
    },
    {
      'title': 'Mucho gimnasio, poco terreno',
      'quote': 'Tienes conocimientos básicos, eso no se puede dudar. Seguramente en el colegio eras de los que se conformaba con un cuatro y no se hacía más problema. Pero debes salir a la calle para probar tus conocimientos.'
    },
    {
      'title': 'Atleta profesional',
      'quote': 'Das todo tu esfuerzo en cada prueba. Te preparas para rendir siempre el mejor examen. Continúa por esta senda y lograrás seguir escalando en el triatlón.'
    },
    {
      'title': 'Seleccionado nacional',
      'quote': 'Tienes todas las cualidades para ser reclutado por cualquier técnico. Aciertas en casi todos los desafíos. Y no le haces el quite al esfuerzo.'
    },
    {
      'title': 'Triatleta de elite mundial',
      'quote': 'No dejas nada al azar. Cuidas cada detalle ante los distintos obstáculos. Resuelves de manera casi perfecta casi todas las inclemencias de un triatlón.'
    },
    {
      'title': 'Un verdadero Ironman',
      'quote': 'No hay nada que se te escape. Eres un deportista todoterreno, que cumple a la perfección en todas las superficies. Resistes a las pruebas más duras.'
    },
  ],
  questions: [
    {
      title: '¿En qué año se disputó por primera vez esta prueba en Pucón?',
      badtext: 'Mal. El primer año que se disputó el Ironman en Pucón fue en 1987.',
      id: 1,
      options: [
        {
          id: 'a',
          text: '1984',
          correct: false
        },
        {
          id: 'b',
          text: '1990',
          correct: false
        },
        {
          id: 'c',
          text: '1987',
          correct: true
        },
        {
          id: 'd',
          text: '1986',
          correct: false
        },
      ]
    },
    {
      title: ' ¿Cuántas veces se impuso en esta prueba Cristián Bustos?',
      badtext: 'Mal. Se impuso en 5 ocasiones.',
      id: 2,
      options: [
        {
          id: 'a',
          text: 'Cuatro',
          correct: false
        },
        {
          id: 'b',
          text: 'Dos',
          correct: false
        },
        {
          id: 'c',
          text: 'Ninguna',
          correct: false
        },
        {
          id: 'd',
          text: 'Cinco',
          correct: true
        },
      ]
    },
    {
      title: '¿Quién es el triatleta masculino que más ha ganado en Pucón?',
      badtext: 'Mal. Es Óscar Galíndez de Argentina. Lisa Bentley lleva seis triunfos también',
      id: 3,
      options: [
        {
          id: 'a',
          text: 'Mark Allen (Estados Unidos)',
          correct: false
        },
        {
          id: 'b',
          text: 'Óscar Galíndez (Argentina)',
          correct: true
        },
        {
          id: 'c',
          text: 'Cristián Bustos (Chile)',
          correct: false
        },
        {
          id: 'd',
          text: 'Reinaldo Colucci (Brasil)',
          correct: false
        },
      ]
    },
    {
      title: '¿Cuántos kilómetros recorren en bicicleta los triatletas en Pucón?',
      badtext: 'Mal. 90 kilómetros.',
      id: 4,
      options: [
        {
          id: 'a',
          text: '80',
          correct: false
        },
        {
          id: 'b',
          text: '85',
          correct: false
        },
        {
          id: 'c',
          text: '70',
          correct: false
        },
        {
          id: 'd',
          text: '90',
          correct: true
        },
      ]
    },
    {
      title: '¿Cuántos títulos tiene Bárbara Riveros en Pucón?',
      badtext: 'Mal. Han sido 4.',
      id: 5,
      options: [
        {
          id: 'a',
          text: 'Cuatro',
          correct: true
        },
        {
          id: 'b',
          text: 'Cinco',
          correct: false
        },
        {
          id: 'c',
          text: 'Ninguno',
          correct: false
        },
        {
          id: 'd',
          text: 'Dos',
          correct: false
        },
      ]
    },
    {
      title: '¿Quién tiene el récord de títulos consecutivos en Pucón?',
      badtext: 'Mal. Ha sido Lisa Bentley.',
      id: 6,
      options: [
        {
          id: 'a',
          text: 'Óscar Galíndez',
          correct: false
        },
        {
          id: 'b',
          text: 'Lisa Bentley',
          correct: true
        },
        {
          id: 'c',
          text: 'Cristián Bustos',
          correct: false
        },
        {
          id: 'd',
          text: 'Bárbara Riveros',
          correct: false
        },
      ]
    },
    {
      title: '¿Cuántos kilómetros de trote deben recorrer los triatletas en Pucón?',
      badtext: 'Mal. Son 21 kilómetros',
      id: 7,
      options: [
        {
          id: 'a',
          text: '18',
          correct: false
        },
        {
          id: 'b',
          text: '25',
          correct: false
        },
        {
          id: 'c',
          text: '21',
          correct: true
        },
        {
          id: 'd',
          text: '30',
          correct: false
        },
      ]
    },
    {
      title: '¿Dónde se realizó el primer triatlón en Chile?',
      badtext: 'Mal. Fue en la Laguna Carén',
      id: 8,
      options: [
        {
          id: 'a',
          text: 'Laguna Aculeo',
          correct: false
        },
        {
          id: 'b',
          text: 'Laguna Sausalito',
          correct: false
        },
        {
          id: 'c',
          text: 'Laguna Carén',
          correct: true
        },
        {
          id: 'd',
          text: 'Lago Villarrica',
          correct: false
        },
      ]
    },
    {
      title: '¿Cuántos chilenos, en varones, han ganado en Pucón?',
      badtext: 'Mal. Sólo una vez.',
      id: 9,
      options: [
        {
          id: 'a',
          text: 'Dos',
          correct: false
        },
        {
          id: 'b',
          text: 'Cinco',
          correct: false
        },
        {
          id: 'c',
          text: 'Uno',
          correct: true
        },
        {
          id: 'd',
          text: 'Tres',
          correct: false
        },
      ]
    },
    {
      title: '¿En qué año se adoptó el recorrido de Medio Ironman, que actualmente se lleva a cabo en Pucón?',
      badtext: 'Mal. El año que se adoptó esta modalidad fue el 2001.',
      id: 10,
      options: [
        {
          id: 'a',
          text: '1999',
          correct: false
        },
        {
          id: 'b',
          text: '2005',
          correct: false
        },
        {
          id: 'c',
          text: '2001',
          correct: true
        },
        {
          id: 'd',
          text: '2008',
          correct: false
        },
      ]
    },
  ]
}